import React, {FC, useEffect, useState} from "react";
import {Form, Select} from "antd";
import {AdminDesignManagement} from "../admin-design-management.type";
import Service1FormPros = AdminDesignManagement.Service1FormPros;

const SbFrom: FC<Service1FormPros> = (props: Service1FormPros) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        if (props.configData.ru && props.configData.ru.sb) {
            setList(props.configData.ru.sb.map((x, i) => ({
                value: i,
                label: x.adminName
            })));
        }
    }, [props.configData]);

    useEffect(() => {
        if (list.length > 0) {
            props.form.setFieldValue('block1', list[0].value);
            props.form.setFieldValue('block2', list[1].value);
        }
    }, [list]);

    return (
        <Form form={props.form} layout="vertical">
            <Form.Item
                label="Блок 1"
                name="block1"
            >
                <Select options={list}/>
            </Form.Item>

            <Form.Item
                label="Блок 2"
                name="block2"
            >
                <Select options={list}/>
            </Form.Item>
        </Form>
    );
};

export default SbFrom;
